import { MAP_OVERLAY_RESET } from './types';

export const resetMapOverlay = () => {
  return { type: MAP_OVERLAY_RESET };
};
